// import Style from '../../../../../component/popup/style.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'

const AddConsumablesPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, Style, buildings = [], meters = [] }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });

    console.log("dropdowns", dropdowns)

    useEffect(() => {
        console.log("currentData", currentData)
        if (currentData?.id) {
            formik.setFieldValue("assetName", currentData?.asset_name || "")
            formik.setFieldValue("category", currentData?.category_id ? Number(currentData?.category_id) : "")
            formik.setFieldValue("location_id", currentData?.location_id || "")
            formik.setFieldValue("vendor_id", currentData?.vendor_id || "")
            formik.setFieldValue("assetCode", currentData?.asset_code || "")
            formik.setFieldValue("brand", currentData?.brand || "")
            formik.setFieldValue("model", currentData?.model || "")
            formik.setFieldValue("purchase_date", currentData?.purchase_date ? moment(currentData?.purchase_date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("warranty_end", currentData?.warranty_end ? moment(currentData?.warranty_end, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("condition", currentData?.condition || "")
        }
    }, [currentData?.id])

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const validationSchema = yup.object().shape({
        asset: yup.string().required('This Field is required'),
        type: yup.string().required('This Field is required'),
        location_id: yup.string().required('This Field is required'),
        vendor_id: yup.string().required('This Field is required'),
        description: yup.string().required('This Field is required'),
        quantity: yup.string().required('This Field is required'),
        price: yup.string().required('This Field is required'),
        purchaseDate: yup.string().required('This Field is required'),
        invoice: yup.string().required('This Field is required'),
    });

    const formik = useFormik({
        initialValues: {
            asset: "",
            type: "",
            location_id: "",
            vendor_id: "",
            description: "",
            quantity: "",
            price: "",
            purchaseDate: "",
            invoice: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "id": currentData?.id
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "asset_id"          : values?.asset,
                "type"              : values?.type,
                "location_id"       : values?.location_id,
                "vendor_id"         : values?.vendor_id,
                "description"       : values?.description,
                "quantity"          : values?.quantity,
                "total_price"       : values?.price,
                "purchasing_date"   : values?.purchaseDate,
                "invoice"           : values?.invoice
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `office-asset/update` : `office-asset/consumable-supply/add`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Asset</FormLabel>

                            <SelectSearch
                                name="asset"
                                placeholder="- Select Asset -"
                                onChange={(val) => {
                                    formik.setFieldValue("asset", val);
                                }}
                                value={formik.values.asset}
                                options={dropdowns?.asset_list?.map((el) => ({
                                    label: `${el.value} (${el?.code})`,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.asset && formik.errors.asset && (
                                <FeildError>{formik.errors.asset}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Type</FormLabel>

                            <SelectSearch
                                name="type"
                                placeholder="- Select Type -"
                                onChange={(val) => {
                                    formik.setFieldValue("type", val);
                                }}
                                value={formik.values.type}
                                options={dropdowns?.consumable_types?.map((el) => ({
                                    label: el,
                                    value: el,
                                }))}
                            />
                            {formik.touched.type && formik.errors.type && (
                                <FeildError>{formik.errors.type}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Location</FormLabel>

                            <SelectSearch
                                name="location_id"
                                placeholder="- Select Location -"
                                onChange={(val) => {
                                    formik.setFieldValue("location_id", val);
                                }}
                                value={formik.values.location_id}
                                options={dropdowns?.asset_locations?.map((el) => ({
                                    label: el.value,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.location_id && formik.errors.location_id && (
                                <FeildError>{formik.errors.location_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Vendor</FormLabel>

                            <SelectSearch
                                name="vendor_id"
                                placeholder="- Select Vendor -"
                                onChange={(val) => {
                                    formik.setFieldValue("vendor_id", val);
                                }}
                                value={formik.values.vendor_id}
                                options={dropdowns?.asset_vendors?.map((el) => ({
                                    label: el.value,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.vendor_id && formik.errors.vendor_id && (
                                <FeildError>{formik.errors.vendor_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Description</FormLabel>
                            <input
                                type={'text'}
                                name={'description'}
                                onChange={formik.handleChange}
                                value={formik.values.description}
                                placeholder='description'
                            />
                            {formik.touched.description && formik.errors.description && (
                                <FeildError>{formik.errors.description}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Quantity</FormLabel>
                            <input
                                type={'number'}
                                name={'quantity'}
                                onChange={formik.handleChange}
                                value={formik.values.quantity}
                                placeholder='Quantity'
                            />
                            {formik.touched.quantity && formik.errors.quantity && (
                                <FeildError>{formik.errors.quantity}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Price</FormLabel>
                            <input
                                type={'number'}
                                name={'price'}
                                onChange={formik.handleChange}
                                value={formik.values.price}
                                placeholder='Total Price'
                            />
                            {formik.touched.price && formik.errors.price && (
                                <FeildError>{formik.errors.price}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Purchase Date</FormLabel>
                            <input
                                type={'date'}
                                name={'purchaseDate'}
                                onChange={formik.handleChange}
                                value={formik.values.purchaseDate}
                                max={moment(new Date()).format("YYYY-MM-DD")}
                                placeholder='Purchase Date'
                            />
                            {formik.touched.purchaseDate && formik.errors.purchaseDate && (
                                <FeildError>{formik.errors.purchaseDate}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel>Invoice</FormLabel>
                            
                            <FileUploadProgressBar
                                value={formik.values.invoice}
                                onChange={(file) => formik.setFieldValue("invoice", file)}
                                loader={formik.values.invoice}
                            // acceptType="pdf"
                            />
                            {
                                (formik.touched.invoice && Boolean(formik.errors.invoice)) && (
                                    <FeildError>{formik.touched.invoice && formik.errors.invoice}</FeildError>
                                )
                            }
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    {
                        (formik?.values?.assignTo || (currentData?.id && currentData?.status == "Assigned" && formik?.values?.status != "Assigned")) ?
                            <p className='text-red-500 text-[14px]'>{formik?.values?.assignTo ? "If you enter an Assign to Date, the asset remains in stock, it gets assigned and then immediately unassigned from the selected user." : "This action will unassign all users from the asset."}</p>
                            :
                            null
                    }
                    {/* <div className={`${Style.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddConsumablesPopup
